import * as wx from '@wecom/jssdk';
import Modal, { IInternalModalAttrs } from 'flarum/common/components/Modal';
import Button from 'flarum/common/components/Button';
import { truncate, getPlainContent } from 'flarum/common/utils/string';
import Discussion from 'flarum/common/models/Discussion';
import app from 'flarum/forum/app';

import { isWeCom } from '../../common/utils';

export interface ShareModalAttrs extends IInternalModalAttrs {
  discussion: Discussion;
}

export default class ShareModal extends Modal<ShareModalAttrs> {
  static shareToWeCom(discussion: Discussion) {
    if (!isWeCom) {
      app.alerts.show('请在企业微信内打开网站');
      return;
    }
    const title = discussion.title();
    const firstPost = discussion.firstPost() || (discussion.posts() as any)?.[0];
    const user = firstPost.user();
    const avatarUrl = user ? user.avatarUrl() : null;
    const content = firstPost.contentPlain() || '';
    const excerpt = truncate(content, 50);
    const favicon = document.querySelector<HTMLLinkElement>('link[rel="shortcut icon"]')?.href;
    wx.shareAppMessage({
      title,
      desc: excerpt,
      link: location.origin + app.route.discussion(discussion),
      imgUrl: avatarUrl || favicon || 'https://res.mail.qq.com/node/ww/wwmng/style/images/index_share_logo$13c64306.png',
    })
      .then(console.log)
      .catch(console.error);
  }

  className() {
    return 'FofShareSocialModal Modal--small';
  }

  title() {
    return '分享到';
  }

  content() {
    return (
      <div className="Modal-body">
        <div className="Form Form--centered">
          <div className="Form-group">
            <Button
              className="Button Button--rounded Button--block Share--wecom"
              // icon={`${shareIcons[network] || `fab fa-${network}`} fa-lg fa-fw`}
              onclick={() => ShareModal.shareToWeCom(this.attrs.discussion)}
            >
              企业微信
            </Button>
          </div>
        </div>
      </div>
    );
  }
}
